import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
  ValidationErrors, // <--- Added this for custom validators
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { CommonHelper } from "app/service/common-helper";
import { TIMER_MINUTES } from "app/service/constants";
import { MessageService } from "app/service/message.service";
import { StorageS } from "app/service/storage";
import Swal from "sweetalert2";

@Component({
  selector: "user-cmp",
  moduleId: module.id,
  templateUrl: "user.component.html",
  styleUrls: ["./user.component.css"],
})
export class UserComponent implements OnInit, OnDestroy {
  public AdminData = JSON.parse(localStorage.getItem("AdminData"));
  public ProfileForm: FormGroup;
  public PasswordForm: FormGroup;
  public model: any = {
    id: null,
    nm: "",
    em: "",
    ph: "",
    aph: "",
    ad: "",
    zc: "",
    company_name: "",
    cin: "",
    dpiit: "",
    gst:"",
    category_type: "",
    category_id: "",
    bank_acc_nm: "",
    bank_acc_no: "",
    ifsc: "",
    branch: "",
    dsc: "",
    zf: [],
  };
  public baseUrl = "user";
  public hasDialog = false;
  public title: string;
  public showOTP = false;
  public isLoading = false;
  private verifiedPhoneNumber = null;
  public userData: any;
  public timer = {
    interval: null,
    show: false,
    minutes: "00",
    seconds: "00",
  };
  public resend = {
    show: false,
    count: 0,
  };
  isPasswordVisible = false;
  isconfirmPasswordVisible = false;
  public categories: any;
  public selectedCategoryName: string = "";
  public mainCategories: any;
  public subCategories: any;
  // Subscription fees
  public productSubscriptionFee = 499;
  public serviceSubscriptionFee = 5499;
  constructor(
    private storageS: StorageS,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.data.subscribe((res) => {
      this.title = res.title;
    });

    // Initialize ProfileForm with custom validators
    this.ProfileForm = new FormGroup({
      Username: new FormControl(this.AdminData.username, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      EmailAddress: new FormControl(this.AdminData.email, [
        Validators.required,
           this.emailDomainValidator()
      ]),
      Phone: new FormControl(this.AdminData.phone, [
        Validators.required,
        Validators.minLength(10),
        this.mobileValidator(), // <--- Custom Mobile Validator
      ]),
      AlternatePhone: new FormControl(this.AdminData.alternate_phone, [
        Validators.minLength(10),
        this.mobileValidator(), // <--- Custom Mobile Validator
      ]),
      Address: new FormControl(this.AdminData.address, [
        Validators.required,
        Validators.minLength(3),
      ]),
      ZipCode: new FormControl(this.AdminData.zipcode, [
        Validators.required,
        Validators.minLength(6),
        this.pinCodeValidator(), // <--- Custom PinCode Validator
      ]),
      CompanyName: new FormControl(this.AdminData.company_name),
      Cin: new FormControl(this.AdminData.cin, [
        Validators.required,
        Validators.maxLength(21),
        this.cinValidator(), // <--- Custom CIN Validator
      ]),
      Dpiit: new FormControl(this.AdminData.dpiit, [
        Validators.required,
        Validators.maxLength(50),
        this.dpiitValidator(), // <--- Custom DPIIT Validator
      ]),
     gst: new FormControl(null, [
  Validators.required,
  this.gstValidator()
]),
      CategoryType: new FormControl(this.AdminData.category_type),
      Category: new FormControl(this.AdminData.category_id),
      SubCategory: new FormControl(this.AdminData.subcategory_id),
      BankAccountName: new FormControl(this.AdminData.bank_acc_nm, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
      ]),
      BankAccountNo: new FormControl(this.AdminData.bank_acc_no, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(18),
          Validators.pattern(/^[0-9]+$/) 
      ]),
      Ifsc: new FormControl(this.AdminData.ifsc, [
        Validators.required,
        Validators.maxLength(11), // IFSC is 11 characters
        this.ifscValidator(), // <--- Custom IFSC Validator
      ]),
      Branch: new FormControl(this.AdminData.branch, [
        Validators.required,
        Validators.maxLength(100),
      ]),
      AboutMe: new FormControl(this.AdminData.description),
    });
    this.PasswordForm = new FormGroup({
      currentPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      newPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
    });
  }
  profileImage: string = '';
normalizeZF(zf: any): any[] {
  if (!zf) return [];

  // If string → parse
  if (typeof zf === 'string') {
    try {
      zf = JSON.parse(zf);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(zf)) return [];

  return zf.map(item => {
    if (!item?.nm) return item;

    // ✅ Full URL → keep as-is
    if (item.url && /^https?:\/\//i.test(item.url)) {
      return item;
    }

    // ✅ Half URL → fix
    const cleanUrl = (item.url || '').replace(/^\/+/, '').replace(/\/+$/, '');
    if (cleanUrl === 'uploads/user') {
      return {
        ...item,
        url: `https://kadaikoditech.com:4000/uploads/user/${item.nm}`
      };
    }

    return item;
  });
}

ParseImage(zf: any): string {
  if (!zf) return '';

  // If string → parse
  if (typeof zf === 'string') {
    try {
      zf = JSON.parse(zf);
    } catch {
      return '';
    }
  }

  if (!Array.isArray(zf) || !zf.length) return '';

  const img = zf.find(i => i?.a === 1) || zf[0];

  if (!img?.nm) return '';

  // ✅ FULL URL → leave untouched
  if (img.url && /^https?:\/\//i.test(img.url)) {
    return img.url;
  }

  // ✅ HALF URL → fix
  const cleanUrl = (img.url || '').replace(/^\/+/, '').replace(/\/+$/, '');

  if (cleanUrl === 'uploads/user') {
    return `https://kadaikoditech.com:4000/uploads/user/${img.nm}`;
  }

  return '';
}


 async ngOnInit() {
  this.userData = await CommonHelper.fetchById(
    this.AdminData.id,
    this,
    "user"
  );
  // ✅ Use API data
  this.model = this.userData?.data || this.userData;
  // ✅ FIX: parse zf if it is string
this.model.zf = this.normalizeZF(this.model.zf);

console.log('ZF AFTER NORMALIZEs:', this.model.zf);


  // ✅ PATCH FORM (IMPORTANT)
  this.ProfileForm.patchValue({
    Username: this.model.nm,
    EmailAddress: this.model.em,
    Phone: this.model.ph,
    AlternatePhone: this.model.aph,
    Address: this.model.ad,
    ZipCode: this.model.zc,
    CompanyName: this.model.company_name,
    Cin: this.model.cin,
    Dpiit: this.model.dpiit,
    gst: this.model.gst,     // ⭐ THIS FIXES GST
    BankAccountName: this.model.bank_acc_nm,
    BankAccountNo: this.model.bank_acc_no,
    Ifsc: this.model.ifsc,
    Branch: this.model.branch,
    AboutMe: this.model.dsc,
  });
  console.log("GST patched:", this.ProfileForm.get("gst")?.value);
  this.loadCategories();
this.profileImage = this.ParseImage(this.model.zf);
console.log('PROFILE IMAGE FINAL:', this.profileImage);


}
  ngOnDestroy(): void {
    if (this.timer.interval) {
      clearInterval(this.timer.interval);
    }
  }
  verifyOtpValidator() {
    const formControl: AbstractControl = this.ProfileForm?.get("otp");
    if (
      formControl &&
      (formControl.errors === null || formControl.errors.verify)
    ) {
      const value: string | null = this.ProfileForm.get("otp").value;

      if (formControl.hasError("verify")) {
        delete formControl.errors.verify;
      }

      if (value.length == 6) {
        return { verify: true };
      }
      return null;
    } else {
      return null;
    }
  }
  verifyOTP() {
    const otp = this.ProfileForm.get("otp").value;
    if (otp.length == 6) {
      this.isLoading = true;
      this.storageS.verifyOTP("user", this.model.id, otp).subscribe(
        (res) => {
          this.isLoading = false;
          this.verifiedPhoneNumber = this.ProfileForm.get("Phone").value;
          this.showOTP = false;
          if (this.ProfileForm.contains("otp")) {
            this.ProfileForm.removeControl("otp");
          }
        },
        (error) => {
          this.isLoading = false;
          this.verifiedPhoneNumber = null;
          if (error.error.message == "expired") {
            this.ProfileForm.get("otp").setErrors({ expired: true });
            this.resend.show = true;
          } else {
            this.ProfileForm.get("otp").setErrors({ invalid: true });
          }
        }
      );
    }
  }
  sendOtp(phoneNumber, resend = false) {
    this.storageS.triggerOTP("user", this.model.id, phoneNumber).subscribe(
      (res: any) => {
        if (!this.ProfileForm.contains("otp")) {
          this.ProfileForm.addControl(
            "otp",
            new FormControl(null, {
              validators: [
                Validators.required,
                this.verifyOtpValidator.bind(this),
              ],
            })
          );
        }
        const errors = this.ProfileForm.get("Phone").errors;
        if (errors) {
          delete errors.duplicate;
          this.ProfileForm.get("Phone").setErrors(errors);
        }
        this.showOTP = true;
        const otpDate =
          typeof res?.data[0]?.otpDate == "string"
            ? new Date(res?.data[0]?.otpDate).getTime()
            : res?.data[0]?.otpDate;
        this.startOTPTimer(otpDate);
        this.isLoading = false;
        this.ProfileForm.get("otp").valueChanges.subscribe((value) => {
          const errors = this.ProfileForm.get("otp").errors;
          if (errors) {
            delete errors.invalid;
            delete errors.expired;
            this.ProfileForm.get("otp").setErrors(errors);
          }
        });
      },
      (error) => {
        if (error?.error?.data?.duplicate) {
          this.ProfileForm.get("Phone").setErrors({ duplicate: true });
        }
        this.isLoading = false;
      }
    );
  }
  resendOtp() {
    const phoneNumber = this.ProfileForm.get("phone").value;
    this.resend.show = false;
    this.resend.count += 1;
    this.sendOtp(phoneNumber, true);
  }
  startOTPTimer(dateTime = null) {
    this.resend.show = false;
    const OTP_EXPIRY_DURATION = TIMER_MINUTES * 60 * 1000; //2minutes
    const startTime = dateTime ? dateTime : Date.now();
    const expiryTime = startTime + OTP_EXPIRY_DURATION;
    this.timer.interval = setInterval(() => {
      const currentTime = Date.now();
      const timeLeft = expiryTime - currentTime;
      if (timeLeft <= 0) {
        this.timer.show = false;
        clearInterval(this.timer.interval);
        if (this.resend.count <= 2) {
          this.resend.show = true;
        }
        // You can add logic to handle expiry here, e.g., disable form submission.
      } else {
        // Format remaining time in MM:SS
        this.timer.show = true;
        this.timer.minutes = `${Math.floor(timeLeft / (60 * 1000))}`;
        this.timer.seconds = `${Math.floor((timeLeft % (60 * 1000)) / 1000)}`;
      }
    }, 1000); // Update every second
  }
  loadCategories() {
    if (this.model?.category_type !== null) {
      let endpoint = this.model.category_type == 1 ? "category" : "service-category";

      this.storageS.getAll(endpoint).subscribe((response) => {
        this.categories = response.data;

        this.mainCategories = this.categories.filter((cat) => cat.p === 0);
        this.subCategories = this.categories.filter((cat) => cat.p !== 0);

        this.ProfileForm.patchValue({ Category: this.model.category_id });

        let selectedCategory = this.mainCategories.find(
          (cat) => cat.id == this.model.category_id
        );
        this.selectedCategoryName = selectedCategory
          ? selectedCategory.nm
          : "Select Category";

        console.log(this.model.subcategory_id);
        this.subCategories = this.subCategories.filter(
          (cat) => cat.id == this.model.subcategory_id
        );
        this.ProfileForm.patchValue({ SubCategory: this.model.subcategory_id }); // if exists
      });
    }
  }
// user.component.ts
markAllAsTouched() {
 // AFTER (Using Object.keys to iterate over control names):
 Object.keys(this.ProfileForm.controls).forEach(key => {
   // key is the string name (e.g., 'Username', 'EmailAddress')
    const control = this.ProfileForm.get(key); // Get the FormControl using the key
    if (control) {
        control.markAsTouched();
    }
 });
}
 async UpdateProfile() {
    this.markAllAsTouched(); // <--- Call this here
    
    if (this.ProfileForm.invalid) {
        // Stop execution if the form is invalid
        return; 
    }
    this.model.nm = this.ProfileForm.get("Username").value;
    this.model.em = this.ProfileForm.get("EmailAddress").value;
    this.model.ph = this.ProfileForm.get("Phone").value;
    this.model.aph = this.ProfileForm.get("AlternatePhone").value;
    this.model.ad = this.ProfileForm.get("Address").value;
    this.model.zc = this.ProfileForm.get("ZipCode").value;
    this.model.company_name = this.ProfileForm.get("CompanyName").value;
    this.model.cin = this.ProfileForm.get("Cin").value;
    this.model.gst = this.ProfileForm.get("gst").value;
    this.model.dpiit = this.ProfileForm.get("Dpiit").value;
    /* this.model.category_type = this.ProfileForm.get("CategoryType").value;
       this.model.category_id = this.ProfileForm.get("Category").value;
       this.model.subcategory_id = this.ProfileForm.get("SubCategory").value;*/
    this.model.bank_acc_nm = this.ProfileForm.get("BankAccountName").value;
    this.model.bank_acc_no = this.ProfileForm.get("BankAccountNo").value;
    this.model.ifsc = this.ProfileForm.get("Ifsc").value;
    this.model.branch = this.ProfileForm.get("Branch").value;
    this.model.dsc = this.ProfileForm.get("AboutMe").value;

    let response = await CommonHelper.save(this);
    if (response) {
      let adminData = {
        username: this.ProfileForm.get("Username").value,
        email: this.ProfileForm.get("EmailAddress").value,
        phone: this.ProfileForm.get("Phone").value,
        alternate_phone: this.ProfileForm.get("AlternatePhone").value,
        address: this.ProfileForm.get("Address").value,
        zipcode: this.ProfileForm.get("ZipCode").value,
        description: this.ProfileForm.get("AboutMe").value,
        type: this.AdminData.type,
        id: this.AdminData.id,
        company_name: this.ProfileForm.get("CompanyName").value,
        cin: this.ProfileForm.get("Cin").value,
        dpiit: this.ProfileForm.get("Dpiit").value,
        gst: this.ProfileForm.get("gst").value,
        /*category_type:this.ProfileForm.get("CategoryType").value,
             category_id:this.ProfileForm.get("Category").value,
             subcategory_id:this.ProfileForm.get("SubCategory").value,*/
        bank_acc_nm: this.ProfileForm.get("BankAccountName").value,
        bank_acc_no: this.ProfileForm.get("BankAccountNo").value,
        ifsc: this.ProfileForm.get("Ifsc").value,
        //is_address:this.ProfileForm.get("Ifsc").value,
        branch: this.ProfileForm.get("Branch").value,
        image: this.model.zf,
      };
      //console.log(this.model.zf);
      localStorage.setItem("AdminData", JSON.stringify(adminData));
      Swal.fire({
        icon: "success",
        title: "Profile updated!",
        text: "Your profile has been updated successfully!",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: "OK",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: "Your profile was not updated due to some error",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: "OK",
      });
    }
  }
  async UpdatePassword() {
    let req = {
      newPassword: this.PasswordForm.get("newPassword").value,
      currentPassword: this.PasswordForm.get("currentPassword").value,
    };
    this.storageS.updatePassword(req, this.AdminData.id).subscribe(
      (res) => {
        Swal.fire({
          icon: "success",
          title: "Password updated!",
          text: "Your password has been updated successfully!",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: "OK",
        });

        this.PasswordForm.reset();
      },
      (err) => {
        Swal.fire({
          icon: "error",
          title: "Invalid Current Password",
          text: "Please enter the correct current password!",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: "OK",
        });
      }
    );
  }
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  toggleConfirmPasswordVisibility() {
    this.isconfirmPasswordVisible = !this.isconfirmPasswordVisible;
  }
  onTypeChange() {
    const categoryType = this.ProfileForm.get("CategoryType").value;
    if (categoryType == "1") {
      this.storageS.getAll("category").subscribe((response) => {
        this.categories = response.data;
        this.mainCategories = this.categories.filter((cat) => cat.p === 0);
        //console.log( this.categories);
      });
    } else if (categoryType == "2") {
      this.storageS.getAll("service-category").subscribe((response) => {
        this.categories = response.data;
        this.mainCategories = this.categories.filter((cat) => cat.p === 0);
        // console.log( this.categories);
      });
    }
  }
  onMainCategoryChange() {
    const selectedCategoryId = this.ProfileForm.get("Category")?.value;

    // Filter subcategories where p equals selectedCategoryId
    this.subCategories = this.categories.filter((cat) => cat.p == selectedCategoryId);
  }
  // --- Start of Custom Validators ---
emailDomainValidator() {
  return (control: AbstractControl): ValidationErrors | null =>{
    if (!control.value) return null;
    const email = control.value.trim();
    // Strong email pattern
    const regex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    if (!regex.test(email)) {
      return { invalidEmailDomain: true };
    }
    return null;
  };
}
  pinCodeValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const pinRegex = /^[1-9][0-9]{5}$/;
      return pinRegex.test(control.value)
        ? null
        : { invalidPincode: true };
    };
  }
  mobileValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      // Regex for 10 digits starting with 6, 7, 8, or 9 (Indian Mobile Numbers)
      const mobileRegex = /^[6-9]\d{9}$/;
      return mobileRegex.test(control.value)
        ? null
        : { invalidMobile: true };
    };
  }
  ifscValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const value = control.value.toUpperCase();
      // IFSC pattern: 4 Alphabets, 0, 6 Alphanumerics (e.g., SBIN0000001)
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      return ifscRegex.test(value)
        ? null
        : { invalidIFSC: true };
    };
  }
  // Custom validator for DPIIT Recognition Number
dpiitValidator() {
  return (control: AbstractControl): ValidationErrors | null =>  {
    if (!control.value) return null;
    const value = control.value.trim().toUpperCase();
    const currentYear = new Date().getFullYear();
    // ---------- DPIIT ----------
    // DPIIT2023ABC123
    const dpiitRegex = /^DPIIT(\d{4})([A-Z0-9]{3,})$/;
    // ---------- DIPP ----------
    // DIPP12345
    const dippPlain5 = /^DIPP\d{3,5}$/;
    // DIPP1234567
    const dippPlain7 = /^DIPP\d{3,7}$/;
    // DIPP1234/IMB or DIPP70724/IMB
    const dippWithIMB = /^DIPP\d{3,7}\/IMB$/;
    // ---- DPIIT check ----
    const dpiitMatch = value.match(dpiitRegex);
    if (dpiitMatch) {
      const year = Number(dpiitMatch[1]);
      if (year < 2016 || year > currentYear) {
        return { invalidDPIITYear: true };
      }
      return null;
    }
    // ---- DIPP check ----
    if (
      dippPlain5.test(value) ||
      dippPlain7.test(value) ||
      dippWithIMB.test(value)
    ) {
      return null;
    }
    // ---- Invalid ----
    return { invalidDPIITFormat: true };
  };
}
  // Custom validator for Corporate Identification Number (CIN)
  cinValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const cin: string = control.value?.toUpperCase();
      if (!cin) return null;

      const currentYear = new Date().getFullYear();

      // 1. Length Check
      if (cin.length !== 21) return { invalidLength: true };

      // 2. Listing Status (L or U)
      if (!["L", "U"].includes(cin.charAt(0))) {
        return { invalidListingStatus: true };
      }

      // 3. Industry Code (5 digits)
      if (!/^\d{5}$/.test(cin.substr(1, 5))) {
        return { invalidIndustryCode: true };
      }
    // State Code → ONLY check 2 uppercase letters
        const stateCode = cin.substr(6, 2);
        if (!/^[A-Z]{2}$/.test(stateCode)) {
          return { invalidStateCode: true };
        }
      // 5. Year of Incorporation (4 digits)
      const year = Number(cin.substr(8, 4));
      if (year > currentYear || year < 1900) {
        return { invalidYear: true };
      }
      // 6. Ownership Type (3 letters)
      const validOwnerships = [
        "PLC",
        "PTC",
        "OPC",
        "LLP",
        "NPL",
        "GOI",
           'SGC', // State Government
      'FTC', // Foreign Company
      'FLC', // Foreign Limited
      'PLP', // Producer Company
      'UID', // Statutory Body
      'ULL',
      'ULT',
      ];
      const ownership = cin.substr(12, 3);
      if (!validOwnerships.includes(ownership)) {
        return { invalidOwnershipType: true };
      }

      // 7. ROC Number (6 digits)
      if (!/^\d{6}$/.test(cin.substr(15, 6))) {
        return { invalidRocNumber: true };
      }
      return null;
    };
  }
  gstValidator() {
  return (control: AbstractControl) => {
    const gst = control.value;
    if (!gst) return null;

    const value = gst.toUpperCase();

    // Length check
    if (value.length !== 15) {
      return { invalidLength: true };
    }

    // State Codes (01–37)
    const validStates = [
      '01','02','03','04','05','06','07','08','09','10',
      '11','12','13','14','15','16','17','18','19','20',
      '21','22','23','24','25','26','27','28','29','30',
      '31','32','33','34','35','36','37','38','97','99'
    ];

    if (!validStates.includes(value.substring(0, 2))) {
      return { invalidStateCode: true };
    }

    // PAN validation (positions 3–12)
    const pan = value.substring(2, 12);
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) {
      return { invalidPAN: true };
    }

    // Entity code (13th char)
    if (!/^[1-9A-Z]$/.test(value.charAt(12))) {
      return { invalidEntityCode: true };
    }

    // Z check (14th char)
    if (value.charAt(13) !== 'Z') {
      return { invalidZCharacter: true };
    }

    // Checksum (15th char)
    if (!/^[0-9A-Z]$/.test(value.charAt(14))) {
      return { invalidChecksum: true };
    }

    return null; // ✅ VALID GST
  };
}
}